/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Option_Remove_ButtonInputs */

const fr_membership_option_remove_button = /** @type {(inputs: Membership_Option_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'option`)
};

/**

* @param {Membership_Option_Remove_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_option_remove_button = /** @type {((inputs?: Membership_Option_Remove_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Option_Remove_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_option_remove_button(inputs)
});